export const GET_USER_SUCCESS = "GET_USER_SUCCESS";
export const GET_USER_FAIL = "GET_USER_FAIL";
export const GET_PUBLIC_USERS_SUCCESS = "GET_PUBLIC_USERS_SUCCESS";
export const GET_PUBLIC_USERS_FAIL = "GET_PUBLIC_USERS_FAIL";
export const GET_PUBLIC_USER_PROFILE_SUCCESS =
  "GET_PUBLIC_USER_PROFILE_SUCCESS";
export const GET_PUBLIC_USER_PROFILE_FAIL = "GET_PUBLIC_USER_PROFILE_FAIL";
export const CLEAR_PUBLIC_USER_PROFILE = "CLEAR_PUBLIC_USER_PROFILE";
export const CHANGE_FOLLOW_STATUS_SUCCESS = "CHANGE_FOLLOW_STATUS_SUCCESS";
export const CHANGE_FOLLOW_STATUS_FAIL = "CHANGE_FOLLOW_STATUS_FAIL";
export const GET_FOLLOWING_USERS_SUCCESS = "GET_FOLLOWING_USERS_SUCCESS";
export const GET_FOLLOWING_USERS_FAIL = "GET_FOLLOWING_USERS_FAIL";
export const CLEAR_FOLLOWING_USERS = "CLEAR_FOLLOWING_USERS";
export const SEARCH_FOLLOWING_USERS_REQUEST = "SEARCH_FOLLOWING_USERS_REQUEST";
export const SEARCH_FOLLOWING_USERS_SUCCESS = "SEARCH_FOLLOWING_USERS_SUCCESS";
export const SEARCH_FOLLOWING_USERS_FAIL = "SEARCH_FOLLOWING_USERS_FAIL";
export const REMOVE_FOLLOWING_USER = "REMOVE_FOLLOWING_USER";
export const GET_FOLLOWERS_USERS_SUCCESS = "GET_FOLLOWERS_USERS_SUCCESS";
export const GET_FOLLOWERS_USERS_FAIL = "GET_FOLLOWERS_USERS_FAIL";
export const CLEAR_FOLLOWERS_USERS = "CLEAR_FOLLOWERS_USERS";
export const SEARCH_FOLLOWERS_USERS_REQUEST = "SEARCH_FOLLOWERS_USERS_REQUEST";
export const SEARCH_FOLLOWERS_USERS_SUCCESS = "SEARCH_FOLLOWERS_USERS_SUCCESS";
export const SEARCH_FOLLOWERS_USERS_FAIL = "SEARCH_FOLLOWERS_USERS_FAIL";
export const REMOVE_FOLLOWERS_USER = "REMOVE_FOLLOWERS_USER";

// Mutual Skills Constants
export const GET_MUTUAL_SKILLS_REQUEST = "GET_MUTUAL_SKILLS_REQUEST";
export const GET_MUTUAL_SKILLS_SUCCESS = "GET_MUTUAL_SKILLS_SUCCESS";
export const GET_MUTUAL_SKILLS_FAIL = "GET_MUTUAL_SKILLS_FAIL";

// Mutual Communities Constants
export const GET_MUTUAL_COMMUNITIES_REQUEST = "GET_MUTUAL_COMMUNITIES_REQUEST";
export const GET_MUTUAL_COMMUNITIES_SUCCESS = "GET_MUTUAL_COMMUNITIES_SUCCESS";
export const GET_MUTUAL_COMMUNITIES_FAIL = "GET_MUTUAL_COMMUNITIES_FAIL";

export const GET_PRIVACY_SETTINGS_SUCCESS = "GET_PRIVACY_SETTINGS_SUCCESS";
export const GET_PRIVACY_SETTINGS_FAIL = "GET_PRIVACY_SETTINGS_FAIL";
export const UPDATE_PRIVACY_SETTINGS_SUCCESS = "UPDATE_PRIVACY_SETTINGS_SUCCESS";
export const UPDATE_PRIVACY_SETTINGS_FAIL = "UPDATE_PRIVACY_SETTINGS_FAIL";

export const BLOCK_USER_SUCCESS = "BLOCK_USER_SUCCESS";
export const BLOCK_USER_FAIL = "BLOCK_USER_FAIL";
export const UNBLOCK_USER_SUCCESS = "UNBLOCK_USER_SUCCESS";
export const UNBLOCK_USER_FAIL = "UNBLOCK_USER_FAIL";
export const GET_BLOCKED_USERS_SUCCESS = "GET_BLOCKED_USERS_SUCCESS";
export const GET_BLOCKED_USERS_FAIL = "GET_BLOCKED_USERS_FAIL";

// Profile View Request Constants
export const CREATE_PROFILE_VIEW_REQUEST_SUCCESS = "CREATE_PROFILE_VIEW_REQUEST_SUCCESS";
export const CREATE_PROFILE_VIEW_REQUEST_FAIL = "CREATE_PROFILE_VIEW_REQUEST_FAIL";
export const GET_RECEIVED_PROFILE_VIEW_REQUESTS_SUCCESS = "GET_RECEIVED_PROFILE_VIEW_REQUESTS_SUCCESS";
export const GET_RECEIVED_PROFILE_VIEW_REQUESTS_FAIL = "GET_RECEIVED_PROFILE_VIEW_REQUESTS_FAIL";
export const GET_SENT_PROFILE_VIEW_REQUESTS_SUCCESS = "GET_SENT_PROFILE_VIEW_REQUESTS_SUCCESS";
export const GET_SENT_PROFILE_VIEW_REQUESTS_FAIL = "GET_SENT_PROFILE_VIEW_REQUESTS_FAIL";
export const ACCEPT_PROFILE_VIEW_REQUEST_SUCCESS = "ACCEPT_PROFILE_VIEW_REQUEST_SUCCESS";
export const ACCEPT_PROFILE_VIEW_REQUEST_FAIL = "ACCEPT_PROFILE_VIEW_REQUEST_FAIL";
export const DENY_PROFILE_VIEW_REQUEST_SUCCESS = "DENY_PROFILE_VIEW_REQUEST_SUCCESS";
export const DENY_PROFILE_VIEW_REQUEST_FAIL = "DENY_PROFILE_VIEW_REQUEST_FAIL";
export const REVOKE_PROFILE_VIEW_REQUEST_SUCCESS = "REVOKE_PROFILE_VIEW_REQUEST_SUCCESS";
export const REVOKE_PROFILE_VIEW_REQUEST_FAIL = "REVOKE_PROFILE_VIEW_REQUEST_FAIL";
export const WITHDRAW_PROFILE_VIEW_REQUEST_SUCCESS = "WITHDRAW_PROFILE_VIEW_REQUEST_SUCCESS";
export const WITHDRAW_PROFILE_VIEW_REQUEST_FAIL = "WITHDRAW_PROFILE_VIEW_REQUEST_FAIL";
export const CLEAR_RECEIVED_PROFILE_VIEW_REQUESTS = "CLEAR_RECEIVED_PROFILE_VIEW_REQUESTS";
export const CLEAR_SENT_PROFILE_VIEW_REQUESTS = "CLEAR_SENT_PROFILE_VIEW_REQUESTS";

// Follow Request Constants
export const CREATE_FOLLOW_REQUEST_SUCCESS = "CREATE_FOLLOW_REQUEST_SUCCESS";
export const CREATE_FOLLOW_REQUEST_FAIL = "CREATE_FOLLOW_REQUEST_FAIL";
export const GET_RECEIVED_FOLLOW_REQUESTS_SUCCESS = "GET_RECEIVED_FOLLOW_REQUESTS_SUCCESS";
export const GET_RECEIVED_FOLLOW_REQUESTS_FAIL = "GET_RECEIVED_FOLLOW_REQUESTS_FAIL";
export const GET_SENT_FOLLOW_REQUESTS_SUCCESS = "GET_SENT_FOLLOW_REQUESTS_SUCCESS";
export const GET_SENT_FOLLOW_REQUESTS_FAIL = "GET_SENT_FOLLOW_REQUESTS_FAIL";
export const ACCEPT_FOLLOW_REQUEST_SUCCESS = "ACCEPT_FOLLOW_REQUEST_SUCCESS";
export const ACCEPT_FOLLOW_REQUEST_FAIL = "ACCEPT_FOLLOW_REQUEST_FAIL";
export const DENY_FOLLOW_REQUEST_SUCCESS = "DENY_FOLLOW_REQUEST_SUCCESS";
export const DENY_FOLLOW_REQUEST_FAIL = "DENY_FOLLOW_REQUEST_FAIL";
export const WITHDRAW_FOLLOW_REQUEST_SUCCESS = "WITHDRAW_FOLLOW_REQUEST_SUCCESS";
export const WITHDRAW_FOLLOW_REQUEST_FAIL = "WITHDRAW_FOLLOW_REQUEST_FAIL";
export const CLEAR_RECEIVED_FOLLOW_REQUESTS = "CLEAR_RECEIVED_FOLLOW_REQUESTS";
export const CLEAR_SENT_FOLLOW_REQUESTS = "CLEAR_SENT_FOLLOW_REQUESTS";

// Notification Constants
export const GET_NOTIFICATIONS_SUCCESS = "GET_NOTIFICATIONS_SUCCESS";
export const GET_NOTIFICATIONS_FAIL = "GET_NOTIFICATIONS_FAIL";
export const ADD_NOTIFICATION = "ADD_NOTIFICATION";
export const MARK_NOTIFICATION_READ_SUCCESS = "MARK_NOTIFICATION_READ_SUCCESS";
export const MARK_NOTIFICATION_READ_FAIL = "MARK_NOTIFICATION_READ_FAIL";
export const MARK_ALL_NOTIFICATIONS_READ_SUCCESS = "MARK_ALL_NOTIFICATIONS_READ_SUCCESS";
export const MARK_ALL_NOTIFICATIONS_READ_FAIL = "MARK_ALL_NOTIFICATIONS_READ_FAIL";
export const DELETE_NOTIFICATION_SUCCESS = "DELETE_NOTIFICATION_SUCCESS";
export const DELETE_NOTIFICATION_FAIL = "DELETE_NOTIFICATION_FAIL";
export const UPDATE_NOTIFICATION_COUNT = "UPDATE_NOTIFICATION_COUNT";
